// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6eee8df1","232":"791256a7","237":"e16b49d4","526":"e9bd8db4","872":"c1e31e0d"}[chunkId] + ".chunk.js";
};